import { parseSearch } from 'helpers/location';

export default parseSearch;
